<template>
  <div class="container">
    <Main :title="taxStrategyTitle" :content="taxStrategyContent" />
  </div>
</template>

<script>
import Main from 'components/singlepage/Main.vue';

export default {
  components: {
    Main,
  },
  async fetch({ store, error }) {
    const { locale } = store.state;
    if (locale !== 'uk') {
      const params = {
        statusCode: 404,
      };
      error(params);
    }
  },
  data() {
    return {
      taxStrategyTitle: this.$t('taxStrategy.title'),
      taxStrategyContent: this.$t('taxStrategy.content'),
    }
  },
}
</script>
